<div class="file-upload pointer-events-none">
  @if(label){
  <label class="font-weight-normal d-block typog-sm mb-2">{{ label + maxFileUpload + ')' }}</label>
  }
  <label for="fileInput" [ngStyle]="contentStyle" class="file-label">
    <mat-icon class="mr-4" *ngIf="uploadFileIcon" [svgIcon]="uploadFileIcon" [ngStyle]="iconSize"></mat-icon>
    <span [innerHTML]="buttonLabel | safeHtml"> </span
  ></label>
  <input
    (change)="fileBrowseHandler($event)"
    type="file"
    id="fileInput"
    class="d-none"
    multiple="true"
    min="2"
    max="2"
    [accept]="suportedFileType"
    [(ngModel)]="fileUploads"
  />
</div>

<div class="uploaded-files row gap-2 align-item-center mt-1" [ngStyle]="baseStyle">
  @for(file of files; track file){
  <div class="mt-2 w-100 align-item-center d-flex gap-1">
    <span class="w-100 text-with-ellipsis">{{ file.filename }} </span
    ><mat-icon class="cursor-pointer" (click)="delFile(file.id)" svgIcon="times-circle"></mat-icon>
  </div>
  }
</div>
